import cookies from 'vue-cookies';
import md5 from 'js-md5';

export default {
  //判断对象是否为空
  isEmptyObject: function (obj) {
    for (var key in obj) {
      return false; //返回false，不为空对象
    }
    return true; //返回true，为空对象
  },

  /**
   * 判断对象是否为空
   * @param data
   * @returns {boolean}
   */
  isNull(data) {
    if (data == undefined || data == null) {
      return true;
    }
    if (typeof data === 'string' && data == '') {
      return true;
    }
    return false;
  },

  // 格式化时间控件的时间
  formatPickerTime: function (time) {
    const data = new Date(time * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    const year = data.getFullYear();
    const month = this.checkTime(data.getMonth() + 1);
    const day = this.checkTime(data.getDate() + 1);
    const hour = this.checkTime(data.getHours() + 1);
    const minute = this.checkTime(data.getMinutes() + 1);
    const second = this.checkTime(data.getSeconds() + 1);
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
  },

  // 不够两位补0
  checkTime: function (i) {
    if (i < 10) {
      i = '0' + i;
    }
    return i;
  },

  /**
   * @desc 函数防抖
   * @param fn 函数
   * @param delay 延迟执行毫秒数
   */
  debounce: function (fn, delay) {
    let timer = null;
    return function () {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(fn, delay); // 简化写法
    };
  },

  /**
   * @desc 函数节流
   * @param fn 函数
   * @param delay 延迟执行毫秒数
   */
  throttle: function (fn, delay) {
    let timer = null;
    return function () {
      let context = this;
      let args = arguments;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          fn.apply(context, args);
        }, delay);
      }
    };
  },

  // 检测当前用户是否登陆
  checkLogin: function () {
    let token = this.$cookies.get('token') || sessionStorage.getItem('token');
    if (token && token !== null && token !== undefined) {
      return true;
    } else {
      return false;
    }
  },

  // 动态改变数组对象中的key
  changeKey: function (arr, key) {
    let newArr = [];
    arr.forEach((item, index) => {
      let newObj = {};
      for (var i = 0; i < key.length; i++) {
        newObj[key[i]] = item[Object.keys(item)[i]];
      }
      newArr.push(newObj);
    });
    return newArr;
  },
  toService: function (pid, accountId, sceneId, fromPageTitle, type) {
    let url = encodeURIComponent(window.location.href);
    let name = cookies.get('memberName') || sessionStorage.getItem('memberName');
    let aname = '';
    if (name) {
      aname = name.replace('"', '').replace('"', '');
    }
    let phone = window.btoa(cookies.get('memberPhone') || sessionStorage.getItem('memberPhone'));
    let userid = cookies.get('memberId') || sessionStorage.getItem('memberId');
    let hbscToken = cookies.get('hbscToken') || sessionStorage.getItem('hbscToken');
    let sign = md5('accountId = jfzx and userId = ' + userid);
    let params = {
      userId: userid,
      userName: aname,
      p: phone,
      // fromPageUrl: url,
      sign: sign,
      pid: pid,
      accountId: accountId,
      sceneId: sceneId,
      entranceId: 'jt',
      fromPageTitle: fromPageTitle,
      user_center_access_token: hbscToken,
      access_token: hbscToken,
    };
    type !== 'noUrl' ? params.fromPageUrl = url : null
    let str = '';
    for (let key in params) {
      str = `${str}${key}=${params[key]}&`;
    }
    str = str.substring(0, str.length - 1);
    return str;
  },
  // 获取地址栏参数
  getUrlAllParam(...args) {
    if (args.length === 0) return undefined;
    const url = decodeURIComponent(window.location.href);
    const reg = args.length === 1
        ? new RegExp(`[&?]${args[0]}=([^&%#]+)`)
        : new RegExp(`[&?](?:${args.join('|')})=([^&%#]+)`);
    const matchArray = url.match(reg);
    return matchArray === null ? undefined : matchArray[1];
  }
};
